import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

// Public Firebase config — НЕ секрет, защита через Security Rules.
const firebaseConfig = {
  apiKey: 'AIzaSyCwnt8O4FBG39ubonOwkuf8DG_ET92HK9Q',
  authDomain: 'turneo-b9ff5.firebaseapp.com',
  projectId: 'turneo-b9ff5',
  storageBucket: 'turneo-b9ff5.firebasestorage.app',
  messagingSenderId: '597563867944',
  appId: '1:597563867944:web:6320123db4d651aa49c61d',
  measurementId: 'G-WH79FGVFGV',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
